module.exports = __webpack_public_path__ + "img/fig9.54ba85f4.png";